// ============================================================
// LA LENTE: la distorsione a barile applicata in post-produzione
// (Effects.jsx) e, soprattutto, come rifarla sui click.
//
// PERCHÉ ESISTE QUESTO FILE
// Il raycast di three parte dalla posizione del mouse e usa la
// proiezione della camera: coordinate dell'immagine RESA. Ma sullo
// schermo non si vede quella — si vede l'immagine deformata dallo
// shader. Le due non coincidono: al centro c'è un ingrandimento, ai
// bordi una compressione, e un punto lontano dal centro può cadere
// decine di pixel più in là. Chi mira un oggetto piccolo lo manca.
//
// Qui si rifà sui numeri esattamente il conto che lo shader fa sui
// pixel, nella stessa direzione: da "dove ho cliccato sullo schermo" a
// "quale punto dell'immagine resa è finito lì".
// ============================================================
export const cfgLente = {
  strength: 0.17,
  cylindricalRatio: 1.25,
  zoom: 1.44,
  attiva: true,
}

// Da NDC dello SCHERMO a NDC dell'immagine RESA (entrambi -1..1).
// Scrive il risultato in `fuori` (un oggetto con x e y) per non allocare.
export function ndcSottoLaLente(x, y, aspetto, fuori) {
  if (!cfgLente.attiva) {
    fuori.x = x; fuori.y = y
    return fuori
  }
  const k = cfgLente.strength
  const scalaX = aspetto * cfgLente.cylindricalRatio
  // stessa sequenza del frammento: zoom, allungamento orizzontale,
  // spinta radiale, e ritorno alle proporzioni di partenza
  let px = x / cfgLente.zoom
  const py = y / cfgLente.zoom
  px *= scalaX
  const r2 = px * px + py * py
  const f = 1 + k * r2
  fuori.x = (px * f) / scalaX
  fuori.y = py * f
  return fuori
}
